export default __webpack_public_path__ + "static/media/avatar.1a84bdf0.svg";